import { render, staticRenderFns } from "./StageList.vue?vue&type=template&id=2da56b81&scoped=true"
import script from "./StageList.vue?vue&type=script&lang=js"
export * from "./StageList.vue?vue&type=script&lang=js"
import style0 from "./StageList.vue?vue&type=style&index=0&id=2da56b81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da56b81",
  null
  
)

export default component.exports